import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { csvUrl, currencyFormatter, getData } from '../CustomUtils'
import { AVERAGE_DEFENSE_COST_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ReportGrid from '../ReportGrid.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const AVERAGE_DEFENSE_COST_REPORT = gql(AVERAGE_DEFENSE_COST_REPORT_QUERY)

export default function AverageDefenseCost({ location }) {
  console.log('AverageDefenseCost rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, AVERAGE_DEFENSE_COST_REPORT, 'averageCost', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    //const resultRows = ResultsGrid(results, 0, 4, location, ['left', 'right', 'right', 'right', 'middle'], null, currencyFormatter(), null, 4, true, [2, 3],)
    const columnFormatters = [
      { columnNumber: 3, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 4, formatter: currencyFormatter().format, align: 'right' },
    ]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/averageCost/average_defense_cost', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{ backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto' }} >
          <ReportHeading title={'Average Cost'} />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            <ReportGrid results={results} viewButtonDataIndex={4} location={location} alignment={['left', 'right', 'right', 'right', 'middle']} columnFormatters={columnFormatters} ignoreRowIndex={4} doesNotHaveNumberRow={true} />
          </tbody>
        </Table>
      </div>
    )
  }
}